module.exports = __webpack_public_path__ + "static/logo_test1-0ba59727b955c9af3418f7c7a4ea64a9.png";